import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./auth.css";
import { Dots } from "../Loader/loader";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/forgot-password`,
        { email },
        { headers: { Accept: "application/json" } }
      );
      setSent(true);
    } catch (err) {
      setError(
        err.response?.status === 429
          ? "Չափից շատ փորձեր։ Խնդրում ենք փորձել մի փոքր ուշ։"
          : err.response?.status === 422
          ? "Մուտքագրեք վավեր էլ. հասցե։"
          : "Չհաջողվեց ուղարկել։ Փորձեք կրկին։"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Գաղտնաբառի վերականգնում</h2>
        {sent ? (
          <div className="auth-alert success">
            Եթե այս էլ. հասցեն գրանցված է, վերականգնման հղումն ուղարկվել է։ Ստուգեք փոստը։
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            {error && <div className="auth-alert">{error}</div>}
            <div className="auth-field">
              <label htmlFor="email">Էլ. հասցե</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button className="auth-btn" type="submit" disabled={submitting}>
              {submitting ? <Dots /> : "Ուղարկել հղումը"}
            </button>
          </form>
        )}
        <p className="auth-switch">
          <Link to="/login">Վերադառնալ մուտքին</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
